// import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import Header from "../../../../Layout/Header";
import { Col, Row } from "react-bootstrap";
import { motion } from "framer-motion";
import toast from "react-hot-toast";

import { updateAppCode, updateEmployeeCode } from "../../../../redux/feature/appSlice";
// import { initializeAppData } from "../../../../AppDataUtils";

import CustomerConstantsList from "../../../../common/CustomerConstants";


const HBLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  //   const [getAppData, setAppData] = useState([]);
   dispatch(updateEmployeeCode(""));


  const handleApplications = (code,employee) => {
    // console.log(">> handleApplications", code);
    dispatch(updateAppCode(code));
    dispatch(updateEmployeeCode(employee));

    // localStorage.setItem("application", code);

    // Calling Application Data
    // initializeAppData(dispatch, code);
   

    if (code === "CUSTOMER") {
      navigate(CustomerConstantsList.CUSTOMER_V4_HB_EMPLOYEE);
    } else if (code === "CUSTOMER") {
      navigate(CustomerConstantsList.CUSTOMER_V4_HB_EMPLOYEE);
    } else if (code === "CUSTOMER") {
      navigate(CustomerConstantsList.CUSTOMER_V4_HB_EMPLOYEE);
    } else if (code === "CUSTOMER") {
      navigate(CustomerConstantsList.CUSTOMER_V4_HB_EMPLOYEE);
    } else {
      // console.log(">> Not Configured ..!");
      toast.error(`${code} not yet Configured..!`, {
        duration: 4000,
        position: "top-right",
      });
    }
  };

  //   const getApplicationMaster = async () => {
  //     let obj = {};
  //     await ItemService.getApplicationMaster(obj).then((item) => {
  //       console.log(">> item! getApplicationMaster", item);
  //       if (item?.status === 200) {
  //         setAppData(item?.data[0].appsName);
  //       } else {
  //         setAppData([]);
  //         console.log(">> Error: Loading getApplicationMaster");
  //       }
  //     });
  //   };

  //Load Page Data
  //   useEffect(() => {
  //     getApplicationMaster();

  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  //   }, []);
  const apps = [
    {
      appName: "Sales",
      description:
        "Automate and streamline supplier engagement and supply chain activities and collaboration.",
      color: "#e0e66c",
      icon: "assets/img/newIcons/app/sales.png",
      appCode: "CUSTOMER",
      employeType:"SALES",
      appStatus: true,
    },
    {
      appName: "Design",
      description:
        "Solutions designed to automate and support your customer engagement and supply chain activities.",
      color: "#39c0f2",
      icon: "assets/img/newIcons/app/design.png",
      appCode: "CUSTOMER",
      employeType:"DESIGN",
      appStatus: true,
    },
    {
      appName: "Prodcution",
      description:
        "AP automation solutions allow buying organizations to receive invoices and process payment",
      color: "#7bc86c",
      icon: "assets/img/newIcons/app/production.png",
      appCode: "CUSTOMER",
      employeType:"PRODUCTION",
      appStatus: true,
    },
    {
      appName: "Operation",
      description:
        "Optimize inventory management,enhance operational efficiency and streamlined logistics.",
      color: "#f39c12",
      icon: "assets/img/newIcons/app/operation.png",
      appCode: "CUSTOMER",
      employeType:"OPERATION",
      appStatus: true,
    },
  ];

  return (
    <main className="dashboard main appLandingPage">
      <Header />
      <div className="appInnerBlock">
        <Row className="justify-content-center subContent width-80">
          {apps.map(
            (card, index) =>
              card.appStatus && (
                <Col
                  key={index}
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  className="mb-4 commLeftRightPadding"
                >
                  <motion.div
                    className="cardApp p-3 text-white d-flex align-items-center"
                    style={{
                      backgroundColor: card.color,
                      borderRadius: "8px",
                    }}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.2, duration: 0.5 }}
                    onClick={() =>
                      handleApplications(card.appCode,card?.employeType)
                    }
                  >
                    {/* Icon or Image on the left */}
                    <div className="icon-container me-4">
                      <img src={card.icon} alt="image1" className="mt-1" />
                    </div>

                    {/* Text Content */}
                    <div>
                      <h3>{card.appName}</h3>
                      <p>{card.description}</p>
                    </div>
                  </motion.div>
                </Col>
              )
          )}
        </Row>
      </div>
    </main>
  );
};

export default HBLogin;
